// Exports true if environment provides native `WeakMap` implementation, whatever that is.

'use strict';

module.exports = (function () {
	if (typeof WeakMap !== 'function') return false;
	return (Object.prototype.toString.call(new WeakMap()) === '[object WeakMap]');
}());



//////////////////
// WEBPACK FOOTER
// ./~/es6-weak-map/is-native-implemented.js
// module id = 2693
// module chunks = 0